export var iconSizeMap = {
  s: 6,
  m: 8,
  l: 10
};
export var getSettings = function getSettings(size) {
  return {
    iconSize: iconSizeMap[size],
    labelSettings: size === 'l' ? {
      variant: 'caption-medium'
    } : {
      lineHeight: '1em',
      size: size === 's' ? 8 : 10
    }
  };
};